/* React */
import React from "react";

/* Ionic */
import { IonGrid, IonRow, IonCol } from "@ionic/react";

/* Components */
import LetterContainer from "src/components/glossary/content-container/letter-container/LetterContainer";
import GlossaryEntry from "src/components/glossary/content-container/glossary-entry/GlossaryEntry";

/* Stylesheet */
import styles from "./ContentContainer.module.scss";
import { GlossaryProps } from "src/shared/interfaces/common/Glossary";

/* Interfaces */
interface ContentContainerProps {
  entries?: GlossaryProps[];
}

const ContentContainer: React.FC<ContentContainerProps> = ({
  entries,
}) => {
  return (
    <IonGrid className={styles.content_container}>
      <LetterContainer />
      <IonRow className={styles.content_row}>
        {entries?.map((entry, index) => {
          return (
            <IonCol key={index} size="3">
              <GlossaryEntry entry={entry} />
            </IonCol>
          );
        })}
      </IonRow>
    </IonGrid>
  );
};

export default ContentContainer;
